import React from 'react';

import ToggleFilter from '../toggle-filter';
import type { Filter, FiltersDictionary, FilterKey } from '../../../types';

interface BooleanFilterProps {
    filtersDictionary: FiltersDictionary;
    filterKeys: FilterKey[];
    currentFilterStates: Filter;
}

const BooleanFilter = ({
    filtersDictionary,
    filterKeys,
    currentFilterStates,
}: BooleanFilterProps) => {
    return (
        <>
            {filterKeys.map((filterKey) => {
                const abundance: number | undefined =
                    filtersDictionary[filterKey]?.values[0]?.abundance;
                const title: string | undefined = filtersDictionary[filterKey]?.label;

                return (
                    <ToggleFilter
                        key={filterKey}
                        filterKey={filterKey}
                        abundance={abundance}
                        title={title}
                        currentFilterStates={currentFilterStates}
                        isListView
                    />
                );
            })}
        </>
    );
};

export default BooleanFilter;
